export {defDescType, defListType, defTermType} from './DeflistSpecs';
